import { IOptions } from "../../api-sdk";
import BaseService from "../baseService";
import {
  IStreamingQuery,
  IStreamingCustomQuery,
  IStreamingPrefixQuery,
  IStreamingUrlResponse,
} from "./streaming.types";
import qs from "qs";
import { filterNonNull } from "../../../utils";
import { AxiosResponse } from "axios";

class StreamingService extends BaseService {
  constructor(options: IOptions) {
    super(options);
  }

  /**
   * Stream the content to client.
   *
   * @param query Streaming query parameters. `content_type` must be one of:
   * `"movie"`, `"series"`, `"live_stream"`, `"reel"`, or `"vertical_stream"` (vertical-format stream content).
   * @returns A Full URL response when `st` is `'custom'`, or the HLS master playlist string when `st` is `'prefix'` or omitted.
   */
  async stream(
    query: IStreamingCustomQuery,
  ): Promise<AxiosResponse<IStreamingUrlResponse>>;
  async stream(query: IStreamingPrefixQuery): Promise<AxiosResponse<string>>;
  async stream(
    query: IStreamingQuery,
  ): Promise<AxiosResponse<IStreamingUrlResponse | string>>;
  async stream(
    query: IStreamingQuery,
  ): Promise<AxiosResponse<IStreamingUrlResponse | string>> {
    return this.request({
      method: "GET",
      url: `/api/v1/stream?${qs.stringify(filterNonNull(query))}`,
    });
  }
}

export default StreamingService;
